import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getImageUrl } from '../../helpers/imageUrls';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';

const BODY_FONT = "'Helvetica Neue', Helvetica, Arial, sans-serif";
const ACCENT = '#6e171a';
const PRICE_COLOR = ACCENT;
const CHIP_COLOR = '#6b7a2f';

const Chevron = ({ flip }) => (
    <svg
        width="44"
        height="84"
        viewBox="0 0 44 84"
        style={{ transform: flip ? 'scaleX(-1)' : 'none', pointerEvents: 'none' }}
    >
        <path d="M8 6 L36 42 L8 78" fill="none" stroke="#fff" strokeWidth="12" />
    </svg>
);

function Index({ dishMenu, onClose }) {

    const { i18n } = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

    const { dish, alldish, currentDish } = dishMenu;

    const [dataDish, setDataDish] = useState(dish);
    const [image, setImage] = useState(false);

    useEffect(() => {
        let active = true;
        setImage(false);

        // Una sola object URL por imagen, compartida y con tope LRU (helpers/imageUrls).
        getImageUrl(`menu-image-h-${dataDish.id}`)
            .then((url) => {
                if (active && url) {
                    setImage(url);
                }
            })
            .catch(() => {});

        return () => { active = false; };
    }, [dataDish]);

    const dishes = alldish || [];
    const flavors = dataDish.flavors || [];

    const navDish = (position) => {
        if (dishes.length < 2) return;
        const menuIndex = dishes.findIndex(item => item.id === dataDish.id);
        const newIndex = (menuIndex + position + dishes.length) % dishes.length;
        setDataDish(dishes[newIndex]);
    };

    const formatPrice = (value) => `$${Number(value).toFixed(2)}`;

    return (
        <div
            onClick={onClose}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0,0,0,0.7)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 30,
                zIndex: 2000,
            }}>

            {dishes.length > 1 && (
                <div
                    onClick={(e) => { e.stopPropagation(); navDish(-1); }}
                    style={{ cursor: 'pointer', flexShrink: 0, padding: 10 }}>
                    <Chevron flip />
                </div>
            )}

            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    width: '68%',
                    maxWidth: 760,
                    maxHeight: '88vh',
                    overflowY: 'auto',
                    backgroundColor: '#fff',
                    display: 'flex',
                    flexDirection: 'column',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.45)',
                    textAlign: 'left',
                }}>

                <img
                    src={image}
                    onContextMenu={(e) => e.preventDefault()}
                    style={{
                        width: '100%',
                        aspectRatio: '1.6',
                        objectFit: 'cover',
                        display: 'block',
                        flexShrink: 0,
                        backgroundColor: '#e6e6e6',
                    }}
                />

                <div style={{
                    padding: '4% 5% 5%',
                    backgroundColor: '#fff',
                    backgroundImage: `url(${require('../../components/layouts/content2/assets/ceramica.png')})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                }}>

                    {currentDish &&
                        <p style={{
                            color: ACCENT,
                            fontFamily: BODY_FONT,
                            fontSize: 'clamp(9px, 1.18vw, 13px)',
                            fontWeight: '700',
                            letterSpacing: 0.5,
                            textTransform: 'uppercase',
                            margin: 0,
                        }}>
                            {langEng ? currentDish.name : translate(i18n.language, currentDish.language, currentDish.name)}
                        </p>
                    }

                    <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 20 }}>
                        <h2 style={{
                            color: '#111',
                            fontFamily: 'Montserrat',
                            fontSize: 'clamp(17px, 2.82vw, 31px)',
                            lineHeight: 1.15,
                            textTransform: 'uppercase',
                            margin: '1.5% 0 2%',
                            whiteSpace: 'pre-line',
                        }}>
                            {`${langEng ? dataDish.name : translate(i18n.language, dataDish.language, dataDish.name)}`.replace(/\\n/g, '\n')}
                        </h2>

                        {(dataDish.price > 0 || flavors.length === 0) &&
                            <span style={{
                                color: PRICE_COLOR,
                                fontFamily: 'Montserrat',
                                fontSize: 'clamp(15px, 2.35vw, 26px)',
                                whiteSpace: 'nowrap',
                            }}>
                                {dataDish.price > 0 ? formatPrice(dataDish.price) : 'Market'}
                            </span>
                        }
                    </div>

                    <p style={{
                        color: '#222',
                        fontFamily: BODY_FONT,
                        fontSize: 'clamp(11px, 1.57vw, 17px)',
                        lineHeight: 1.5,
                        whiteSpace: 'pre-line',
                        margin: 0,
                    }}>
                        {langEng
                            ? `${dataDish.regular_decription.replace(/\\n/g, '\n')}`
                            : `${translateMenu(
                                i18n.language,
                                dataDish.language,
                                dataDish.regular_decription,
                                'regular_decription'
                            )}`
                        }
                    </p>

                    {flavors.length > 0 &&
                        <>
                            <div style={{ width: '23%', height: 2, backgroundColor: '#111', margin: '4% 0 3%' }} />

                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(3, 1fr)',
                                gap: 10,
                            }}>
                                {flavors.map((item, key) => (
                                    <div key={key} style={{
                                        backgroundColor: CHIP_COLOR,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        gap: '0.8em',
                                        padding: '0.65em 0.9em',
                                        color: '#fff',
                                        fontFamily: BODY_FONT,
                                        fontSize: 'clamp(10px, 1.33vw, 14px)',
                                        fontWeight: '700',
                                        boxSizing: 'border-box',
                                        minWidth: 0,
                                    }}>
                                        <span style={{ lineHeight: 1.25, overflowWrap: 'anywhere' }}>
                                            {item.name}
                                        </span>
                                        <span style={{ whiteSpace: 'nowrap' }}>
                                            {item.price > 0 ? formatPrice(item.price) : 'Market'}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </>
                    }
                </div>
            </div>

            {dishes.length > 1 && (
                <div
                    onClick={(e) => { e.stopPropagation(); navDish(1); }}
                    style={{ cursor: 'pointer', flexShrink: 0, padding: 10 }}>
                    <Chevron />
                </div>
            )}
        </div>
    );
}

export default Index;
